import Animation from "./californio.animation.js";

const Californio = {
  //#region ShowBrand
  showBrand: function () {
    /**
     * Função que exibe a marca da Californio e redireciona para o site da Californio
     * */
    console.info(
      "%cCalifórnio - MKT Digital%c\nhttps://www.californio.com.br/",
      "color: #111; background: #edff7f; font-size: 16px; font-weight: 400; font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; padding: 6px 12px; margin: 8px 8px 2px; border: 1px solid #888;",
      "color: gray !important; font-size: 12px; font-weight: 400; font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; padding: 6px 12px; margin: 2px 8px;",
    );
  },

  // Função para desabilitar o scroll da página
  disableScroll: () => {
    document.body.style.overflow = "hidden";
  },

  // Função para habilitar o scroll da página
  enableScroll: () => {
    document.body.style.overflow = "auto";
  },

  //#region Sleep
  sleep: function (seconds = 0) {
    /**
     * Função que retorna uma Promise que resolve após um determinado tempo em segundos
     * @param {number} seconds - Tempo em segundos
     * */

    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
  },

  //#region Init
  init: function () {
    /**
     * Função que iniancializa todas as funções da Californio
     */

    const _this = this;

    Animation.init();

    _this.showBrand();
  },
};

export default Californio;
